var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHomeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 34.112,
    viewBox: "0 0 30 34.112",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_250",
    "data-name": "Pfad 250",
    d: "M24,6.944,9,15.005V41.056H21v-14h6v14H39V15.005ZM37,39.056H29v-14H19v14H11V16.2L24,9.215,37,16.2Z",
    transform: "translate(-9 -6.944)",
    fill: "#161615"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHomeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Home_icon.16ed2601b04c9ad3b4d0e3e4c3a652e5.svg";